import React from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'
import { BalanceRouter } from './balance/_router'
import { CardBackfillRouter } from './card-backfill/_router'
import { EburyRouter } from './ebury/_router'
import { ExactCleanupRouter } from './exact-cleanup/_router'
import { ExactGapsRouter } from './exact-gaps/_router'
import { InProgressRouter } from './in-progress/_router'
import { ReconciliationRouter } from './reconciliation/_router'
import { RemindersRouter } from './reminders/_router'
import { UnallocatedRouter } from './unallocated/_router'

export const PaymentRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--payment']}>
    <Route path='in-progress/*' element={<InProgressRouter />} />
    <Route path='balance/*' element={<BalanceRouter />} />
    <Route path='reconciliation/*' element={<ReconciliationRouter />} />
    <Route path='reminders/*' element={<RemindersRouter />} />
    <Route path='ebury/*' element={<EburyRouter />} />
    <Route path='exact-cleanup/*' element={<ExactCleanupRouter />} />
    <Route path='exact-gaps/*' element={<ExactGapsRouter />} />
    <Route path='unallocated/*' element={<UnallocatedRouter />} />
    <Route path='card-backfill/*' element={<CardBackfillRouter />} />
  </SubRouter>
))
